// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-8aaa3146] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.empty-content[data-v-8aaa3146] {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  /* In case of using in a flex container - flex in advance */
  flex-grow: 1;
  padding: var(--default-grid-baseline);
}
.modal-wrapper .empty-content[data-v-8aaa3146] {
  margin-top: 5vh;
  margin-bottom: 5vh;
}
.empty-content__icon[data-v-8aaa3146] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin: 0 auto 15px;
  opacity: 0.4;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 64px;
}
.empty-content__icon[data-v-8aaa3146] svg {
  width: 64px !important;
  height: 64px !important;
  max-width: 64px !important;
  max-height: 64px !important;
}
.empty-content__name[data-v-8aaa3146] {
  margin-bottom: 10px;
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  line-height: 30px;
}
.empty-content__description[data-v-8aaa3146] {
  color: var(--color-text-maxcontrast);
  text-align: center;
  text-wrap-style: balance;
}
.empty-content__action[data-v-8aaa3146] {
  margin-top: 8px;
}
.modal-wrapper .empty-content__action[data-v-8aaa3146] {
  margin-top: 20px;
  display: flex;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcEmptyContent-CHVEJoER.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,2DAA2D;EAC3D,YAAY;EACZ,qCAAqC;AACvC;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,aAAa;AACf","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-8aaa3146] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.empty-content[data-v-8aaa3146] {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  /* In case of using in a flex container - flex in advance */\n  flex-grow: 1;\n  padding: var(--default-grid-baseline);\n}\n.modal-wrapper .empty-content[data-v-8aaa3146] {\n  margin-top: 5vh;\n  margin-bottom: 5vh;\n}\n.empty-content__icon[data-v-8aaa3146] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 64px;\n  height: 64px;\n  margin: 0 auto 15px;\n  opacity: 0.4;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 64px;\n}\n.empty-content__icon[data-v-8aaa3146] svg {\n  width: 64px !important;\n  height: 64px !important;\n  max-width: 64px !important;\n  max-height: 64px !important;\n}\n.empty-content__name[data-v-8aaa3146] {\n  margin-bottom: 10px;\n  text-align: center;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 30px;\n}\n.empty-content__description[data-v-8aaa3146] {\n  color: var(--color-text-maxcontrast);\n  text-align: center;\n  text-wrap-style: balance;\n}\n.empty-content__action[data-v-8aaa3146] {\n  margin-top: 8px;\n}\n.modal-wrapper .empty-content__action[data-v-8aaa3146] {\n  margin-top: 20px;\n  display: flex;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
